import React from 'react';

type Progress = {
  totalAnalyses: number;
  last30dAnalyses: number;
  lastAnalysisAt?: string;
};

export function ProgressStats({ data }: { data: Progress | null }): JSX.Element {
  if (!data) {
    return <div className="text-sm text-muted-foreground">No data yet</div>;
  }

  return (
    <div className="grid grid-cols-3 gap-4 text-center">
      <div>
        <div className="text-2xl font-bold">{data.totalAnalyses}</div>
        <div className="text-xs text-muted-foreground">Total analyses</div>
      </div>
      <div>
        <div className="text-2xl font-bold">{data.last30dAnalyses}</div>
        <div className="text-xs text-muted-foreground">Last 30 days</div>
      </div>
      <div>
        <div className="text-2xl font-bold">
          {data.lastAnalysisAt ? new Date(data.lastAnalysisAt).toLocaleDateString() : '—'}
        </div>
        <div className="text-xs text-muted-foreground">Last analysis</div>
      </div>
    </div>
  );
}

export default ProgressStats;
